module.exports = __webpack_public_path__ + "media/images/guide-2t-215a0dd4d5ef901ad6bab932c24a16a0.png";